import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { ButtonComponent, DatepickerDirective, FormFieldComponent, FormGroupComponent, FormRowComponent, IconComponent, InputDirective, LabelComponent, NotificationService, OptionComponent, PlaceholderComponent, SelectComponent, SubHeaderComponent, ToggleSwitchComponent } from '@pansa/ui';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { EventService } from '../../services/event.service';
import { EventDTO, EventTypeEnum } from '../../models/event.model';
import { FieldErrorComponent } from '@app/shared/components/field-error/field-error.component';

@Component({
  selector: 'rqa-add-event',
  templateUrl: './add-event.component.html',
  styleUrls: ['./add-event.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SubHeaderComponent,
    ButtonComponent,
    FormRowComponent,
    FormGroupComponent,
    FormFieldComponent,
    LabelComponent,
    InputDirective,
    IconComponent,
    ToggleSwitchComponent,
    CommonModule,
    DatepickerDirective,
    SelectComponent,
    OptionComponent,
    PlaceholderComponent,
    FieldErrorComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddEventComponent implements OnInit {
  private fb = inject(UntypedFormBuilder);
  private eventService = inject(EventService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private notificationService = inject(NotificationService);

  form: FormGroup = this.fb.group({
    date: this.fb.control('', Validators.required),
    eventType: this.fb.control('', Validators.required),
    reason: this.fb.control(''),
    repeatable: this.fb.control(false),
    messagePl: this.fb.control(''),
    messageEn: this.fb.control('')
  });
  minDate = formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
  eventTypeOptions: string[] = Object.values(EventTypeEnum);
  editMode: boolean = false;


  ngOnInit(): void {
    const eventData = this.router.currentNavigation()?.extras?.state ?? history.state;
    this.editMode = this.route.snapshot.paramMap.has('id');
    if (eventData) {
      this.setFormValues(eventData);
    }
  }

  onSubmit() {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      return;
    }

    const date = new Date(this.form.value.date);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const payload = {
      ...this.form.value,
      date: `${year}-${month}-${day}`,
      active: true
    };

    if (this.editMode) {
      this.eventService.updateEvent(payload).subscribe(() => {
        this.notificationService.success({ title: 'Sukces', subTitle: 'Pomyślnie edytowano wydarzenie' })
        this.eventService.refreshEvents();
        this.onGoBack();
      })
    } else {
      this.eventService.createEvent(payload).subscribe(() => {
        this.notificationService.success({ title: 'Sukces', subTitle: 'Dodano nowe wydarzenie' })
        this.eventService.refreshEvents();
        this.onGoBack();
      });
    }

  }

  onGoBack() {
    this.router.navigate(['/events']);
  }

  private setFormValues(eventData: EventDTO): void {
    this.form.patchValue({
      date: eventData.date,
      eventType: eventData.eventType,
      reason: eventData.reason,
      repeatable: eventData.repeatable,
      messagePl: eventData.messagePl,
      messageEn: eventData.messageEn,
    })
  }

}
